import { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import upload from "../../../images/Upload.svg";
import {
  CreateBranchForVfs,
  VfsLoader,
} from "../../../Redux/Action/VfsAction";
import { useLocation } from "react-router";
import { X } from "lucide-react";
import Select from "react-select";
import { components } from "react-select";
import {
  GetVfsuklpZoneWiseBranchList,
  VfsuklpBranchlist,
  VfsuklpRoleCreate,
} from "../../../Redux/Action/VfsuklpAction";
import { GetCountryList } from "../../../Redux/Action/CorporateAction";

export const CreateRole = ({ setCorporatemodel, corporatemodel, zoneList }) => {
  
  const dispatch = useDispatch();
  // get token from local storage
  const authToken = localStorage.getItem("Admin");
  const corporateID = JSON.parse(authToken)?.data?.corporateID;
  const [selectZone, setSelectZone] = useState([]);
  const [selectRole, setSelectRole] = useState("");
  const [selectBranch, setSelectBranch] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [selectBranchLabel, setSelectBranchLabel] = useState([]);
  const [selectZoneLabel, setSelectZoneLabel] = useState([]);

  const BranchList = useSelector((state) => state.Vfsuklp.ZoneWiseBranchList);
  

  useEffect(() => {
    if (selectZoneLabel.length > 0) {
      const data={
        zone:selectZoneLabel
      }
      dispatch(GetVfsuklpZoneWiseBranchList(data));
    } else {
      setBranchList([]); // Clear branch list if no zone is selected
    }
  }, [selectZoneLabel, dispatch]);

  useEffect(() => {
    if (BranchList && BranchList.data) {
      
      const branches = BranchList.data.map((branch) => ({
        value: branch._id,
        label: branch.corporateName,
      }));
      
      setBranchList(branches);
    }
  }, [BranchList]);

  const uk_roles = [
    { value: "accountant", label: "Accountant" },
    { value: "sales", label: "Sales" },
    { value: "support", label: "Support" },
  ];
  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(VfsuklpRoleCreate(roleData, setCorporatemodel));
  };

  const [roleData, setRoleData] = useState({
    name: "",
    email: "",
    contact: "",
    corporateId: corporateID,
    zone: [],
    role: selectRole,
    branches: [],
    isEmailMasked: false,
    isContactMasked: false,
    countryCode: "+91",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRoleData((prev) => ({
      ...prev,
      [name]: value, // dynamically update based on input "name"
    }));
  };
  const handleZoneSelect = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    const label = selectedOptions
      ? selectedOptions.map((option) => option.label)
      : [];
    setSelectZone(values);
    setSelectZoneLabel(label);
    setSelectBranch([]); // Reset branch selection when zone changes
    setSelectBranchLabel([]);
    setRoleData((prev) => ({
      ...prev,
      zone: label,
      branches: [], // Reset branch in roleData
    }));
  };
  const handleBranchSelect = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    const label = selectedOptions
      ? selectedOptions.map((option) => option.label)
      : [];
    setSelectBranch(values);
    setSelectBranchLabel(label);
    setRoleData((prev) => ({
      ...prev,
      branches: values,
    }));
  };
  const handleRoleSelect = (selectedOptions) => {
    const values = selectedOptions.value;
    setRoleData((prev) => ({
      ...prev,
      role: values,
    }));
  };
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      //   minWidth: '150px',
      //   maxWidth: window?.innerWidth > 600 && '210px',
      borderColor: state.isFocused ? "#fff100" : "#ececec",
      boxShadow: "none",
      "&:hover": { borderColor: "#ececec" },
    }),
    placeholder: (base) => ({
      ...base,
      color: "#262626",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "2px 8px",
      minHeight: "38px", // instead of fixed height
      height: "auto", // allow it to expand
      flexWrap: "wrap", // let multiple values wrap
      overflow: "visible", // show all selected
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      color: "#262626",
      height: "38px",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "transparent",
      color: "black",
      display: "flex",
      alignItems: "center",
      "&:hover": {
        backgroundColor: "#f8f8f8",
      },
    }),
    menuList: (provided) => ({
      ...provided,
      //   maxHeight : '200px',
      //   overflowY : 'auto',
      padding: 0,
    }),
  };
  const CheckboxOption = (props) => {
    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null} // prevent default behavior
          className="mr-2"
        />
        <label>{props.label}</label>
      </components.Option>
    );
  };
  const customStylescountrycode = {
    control: (provided, state) => ({
        ...provided,
        minWidth: '100px',
        maxWidth: '120px',
        overflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // maxWidth: window?.innerWidth > 600 && '210px',
        borderColor: state.isFocused ? '#fffce1' : '#fffce1',
        boxShadow: 'none',
        backgroundColor: '#fffce1',
        '&:hover': { borderColor: '#fffce1' },
    }),
    placeholder: (base) => ({
        ...base,
        color: '#262626',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '2px 4px',
        height: '50px',
        overflow: 'hidden',
        borderColor: '#d1d5db',
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: '#262626',
        height: '50px',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: 'transparent',
        color: 'black',
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            backgroundColor: '#f8f8f8',
        },
    }),
    menuList: (provided) => ({
        ...provided,
        maxHeight: '200px',
        overflowY: 'auto',
        padding: 0,
    }),
};
  // country code
      const [countryCodeoption, setCountryCodeOption] = useState("");
    const countryList = useSelector((state) => state?.corporateData?.CountryList?.data);
    useEffect(() => {
      if (countryList && countryList?.length > 0) {
          const con = countryList.map((item) => ({
              label: `+${item.phonecode}`,
              value: item.phonecode,
          }));
          setCountryCodeOption(con);
      }
  }, [countryList]);
   useEffect(() => {
        dispatch(GetCountryList());
    }, [dispatch]);
  
  return (
    <>
      <div
        className={`fixed right-0 top-0 h-full w-[500px] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
          corporatemodel ? "translate-x-0" : "translate-x-full"
        } flex flex-col`}
      >
        <div className="flex items-center justify-between px-6 py-2 border-b border-gray-200 bg-[#FCDD00]">
          <div className="flex items-center">
            <h2 className="my-[7px] text-xl font-semibold text-gray-900">
              Add Team Member 
            </h2>
          </div>
          <button
            onClick={() => setCorporatemodel(false)}
            className="p-2 transition-colors duration-200 rounded-full hover:bg-white hover:bg-opacity-50"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>
        <div className="flex-1 p-6 space-y-6 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400">
          <form onSubmit={handleSubmit} id="formID">
            <div className="flex flex-col gap-3 mb-5 ">
              <div className="flex-col w-full gap-3 md:flex">
                {/* name */}
                <div className="flex flex-col w-full gap-1">
                  <span className="font-Poppins text-[15px] xl:text-base">
                    Name<span className="text-[#fc0000]">*</span> :
                  </span>
                  <input
                    className="py-[10px] xl:py-3 px-4 rounded-lg bg-[#FFFCE1] text-sm  outline-[#FCDD00]"
                    type="text"
                    placeholder="Enter Name"
                    id="name"
                    name="name"
                    value={roleData.name}
                    onChange={handleChange}
                    required
                    autoComplete="off"
                    maxLength={50}
                  />
                </div>
                <div className="flex flex-col w-full gap-1">
                  <span className="font-Poppins text-[15px] xl:text-base">
                    Email Id<span className="text-[#fc0000]">*</span> :
                  </span>
                  <input
                    className="py-[10px] xl:py-3 px-4 rounded-lg bg-[#FFFCE1] text-sm  outline-[#FCDD00]"
                    type="email"
                    placeholder="Enter Email Id"
                    id="email"
                    name="email"
                    value={roleData.email}
                    onChange={handleChange}
                    required
                    autoComplete="off"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <span className="font-Poppins text-[15px] xl:text-base">
                    Contact No<span className="text-[#fc0000]">*</span> :
                  </span>
                  <div className="flex">
                  <Select
                        options={countryCodeoption || [{label:"+91",value:"91"}]}
                        placeholder={("select country" || "").substring(0, 5)}
                        name="countryCode"
                        id="countryCode"
                        value={
                          countryCodeoption &&
                          countryCodeoption?.find(
                            (option) => option.value == roleData.countryCode
                          )|| { label: "+91", value: "91" }
                        }
                        onChange={(e) => {
                          setRoleData((prev) => ({
                            ...prev,
                            countryCode: e.value,
                          }));
                        }}
                        isSearchable={true}
                        styles={customStylescountrycode}
                        className="w-[100px] sm:w-[120px] " // fixed width select
                        required
                      />
                  <input
                    className="py-[10px] xl:py-3 px-4 text-sm rounded-lg  bg-[#FFFCE1]  outline-[#FCDD00] w-full"
                    type="tel"
                    placeholder="Enter Contact No"
                    id="contact"
                    name="contact"
                    value={roleData.contact}
                    onChange={(e) => {
                      const re = /^[0-9\b]+$/;
                      if (e.target.value === "" || re.test(e.target.value)) {
                        handleChange(e);
                      }
                    }}
                    required
                    autoComplete="off"
                    minLength={0}
                  />
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-1">
                <span className="font-Poppins text-[15px] xl:text-base">
                  Role<span className="text-[#fc0000]">*</span> :
                </span>
                <Select
                  options={uk_roles}
                  placeholder="Select Role"
                  value={uk_roles.find((option) => option.value === selectRole)}
                  onChange={(option) => {
                    setSelectRole(option?.value);
                    handleRoleSelect(option);
                  }}
                  onMenuClose={() => setSelectRole('')}
                  isSearchable={true}
                  closeMenuOnSelect={true}
                  isClearable={false}
                  styles={customStyles}
                  hideSelectedOptions={false}
                  required
                />
              </div>
              {/* Zone */}
              <div className="flex flex-col gap-1">
                <span className="font-Poppins text-[15px] xl:text-base">
                  Zone<span className="text-[#fc0000]">*</span> :
                </span>
                <Select
                  options={zoneList}
                  placeholder="Select Zone"
                  value={zoneList?.filter((option) =>
                    selectZone?.includes(option.value)
                  )}
                  onChange={handleZoneSelect}
                  isSearchable={true}
                  closeMenuOnSelect={false}
                  isMulti={true}
                  isClearable={false}
                  styles={customStyles}
                  hideSelectedOptions={false}
                  components={{
                    Option: CheckboxOption,
                    IndicatorSeparator: () => null,
                  }}
                  required
                />
              </div>
              {/* Zone vise Branch */}
              <div className="flex flex-col gap-1">
                <span className="font-Poppins text-[15px] xl:text-base">
                  Branch<span className="text-[#fc0000]">*</span> :
                </span>
                <Select
                  options={branchList}
                  placeholder="Select branch"
                  value={branchList?.filter((option) =>
                    selectBranch?.includes(option.value)
                  )}
                  onChange={handleBranchSelect}
                  isSearchable={true} 
                  closeMenuOnSelect={false}
                  isMulti={true}
                  isClearable={false}
                  hideSelectedOptions={false}
                  components={{
                    Option: CheckboxOption,
                    IndicatorSeparator: () => null,
                  }}
                  menuPlacement="top"   // ✅ Show menu above
                  menuPosition="absolute"  // ✅ Use absolute (not fixed)
                  menuPortalTarget={document.body} // ✅ Ensure menu is not clipped by parent
                  styles={{
                    ...customStyles,
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // keep on top
                  }}
                  isDisabled={selectZone.length === 0}
                  required
                />
              </div>
            </div>
            <hr></hr>
            <div className="flex flex-col gap-3 py-3">
            <span className="font-Poppins text-[15px] xl:text-base">
                    Masking<span className="text-[#fc0000]">*</span> :
                </span>
            <div className="flex flex-row gap-5 pl-2">
    {/* Email checkbox */}
    <label className="flex items-center gap-2 text-sm font-Poppins">
      <input
        type="checkbox"
        name="masking"
        value="isEmailMasked"
        onChange={(e) => {
          setRoleData((prev) => ({
            ...prev,
            isEmailMasked: e.target.checked,
          }));
        }}
        className="w-4 h-4 accent-[#FCDD00] cursor-pointer"
      />
      Email
    </label>

    {/* Contact checkbox */}
    <label className="flex items-center gap-2 text-sm font-Poppins">
      <input
        type="checkbox"
        name="masking"
        value="isContactMasked"
        onChange={(e) => {
          setRoleData((prev) => ({
            ...prev,
            isContactMasked: e.target.checked,
          }));
        }}
        className="w-4 h-4 accent-[#FCDD00] cursor-pointer"
      />
      Contact
    </label>
  </div>
            </div>
          </form>
        </div>
        {/* Footer Actions */}
        <div className="flex flex-row gap-3 p-6 border-t border-gray-200 bg-gray-50">
          <button
            type="submit"
            form="formID"
            className="w-full bg-[#FCDD00] text-black py-3 px-4 rounded-lg hover:bg-[#FCDD00] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200 font-medium"
          >
            Save
          </button>

          <button
            onClick={() => setCorporatemodel(false)}
            className="flex items-center justify-center w-full px-4 py-3 font-medium text-gray-700 transition-colors duration-200 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          >
            Close
          </button>
        </div>
      </div>
    </>
  );
};